module.exports = __webpack_public_path__ + "static/evergreen-table-context-menu-0e4fae4228c299258be6468fb4d55dfa.png";